import { render, staticRenderFns } from "./WebPartListDataDesigner.vue?vue&type=template&id=245a5833&scoped=true&"
import script from "./WebPartListDataDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartListDataDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartListDataDesigner.vue?vue&type=style&index=0&id=245a5833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a5833",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245a5833')) {
      api.createRecord('245a5833', component.options)
    } else {
      api.reload('245a5833', component.options)
    }
    module.hot.accept("./WebPartListDataDesigner.vue?vue&type=template&id=245a5833&scoped=true&", function () {
      api.rerender('245a5833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartListDataDesigner.vue"
export default component.exports